import { APIHandler } from "../base";
import { FeedbackRequest } from "../../common/interfaces/comps/feedback-request.interface";

export const sendFeedback = (companyId: number, request: FeedbackRequest) =>
    APIHandler.post(`/admin/${companyId}/feedbacks/upgradeEmail`, request);
